/* eslint-disable eqeqeq */
import React, { useEffect } from 'react';
import useTranslation from 'next-translate/useTranslation';
import Image from 'next/image';
import dynamic from 'next/dynamic';
import Skeleton from 'react-loading-skeleton';

import { numberSplitter } from '@/constants/helper';
import { hooks as viewHooks } from '@/domains/view';
import { CurrencySmall } from '@/icons/index';
import {
  ActiveLink,
  Button,
  Tab,
  TabContentItem,
  TabPanel,
  Tabs,
  TabContent,
} from '@/ui/index';

import styles from './styles.module.scss';

const SliderModule = dynamic(() => import('react-slick'), { ssr: false });

const BookNumber = ({ tabs }) => {
  const { t } = useTranslation();
  const levels = tabs?.levels?.filter((item) => item?.levelId != 11);
  const [currentTab, setCurrentTab] = React.useState(0);
  const [levelId, setLevelId] = React.useState(levels[0]?.levelId);
  const [numberList, setNumberList] = React.useState([]);
  const [isImageLoaded, setIsImageLoaded] = React.useState(false);

  const changedTag = levels?.map((item) => {
    if (item?.levelId === '4') {
      return {
        id: item?.id,
        name: t('common:simple'),
        levelId: item?.levelId,
      };
    }
    return item;
  });

  const sliderSetting = {
    dots: false,
    infinite: true,
    speed: 500,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    focusOnSelect: false,
    pauseOnHover: false,
    draggable: false,
    autoplaySpeed: 5000,
    lazyLoad: 'ondemand',
  };

  const [beautifulNumbersMutation] = viewHooks.useBeautifulNumbers();

  useEffect(() => {
    beautifulNumbersMutation({ levelId })
      .unwrap()
      .then((res) => {
        setNumberList(res?.data);
      });
  }, [levelId]);

  const renderTab = (item, index) => {
    return (
      <Tab
        key={index}
        onClick={() => {
          setCurrentTab(index);
          setLevelId(item?.levelId);
        }}
        itemScope
        itemType='https://schema.org/Offer'
      >
        {item?.name}
      </Tab>
    );
  };

  const renderTabContent = (item, index) => {
    return (
      <div
        className={styles.item}
        key={index}
        itemScope
        itemType='https://schema.org/Offer'
      >
        <div className={styles.number}>
          {item?.prefix}-
          <span className={styles.red}>{numberSplitter(item?.msisdn)}</span>
        </div>
        <div className={styles.price}>
          <div className={styles.currentPrice}>
            {item?.price}{' '}
            <CurrencySmall width={20} className={styles.red_icon} />
          </div>
        </div>
      </div>
    );
  };

  if (!numberList || numberList.length === 0) {
    return null;
  }

  return (
    <div
      className={'wrapper section'}
      itemScope
      itemType='https://schema.org/OfferCatalog'
    >
      <div className={styles.container}>
        <div className={styles.left}>
          <div className={styles.header}>
            <div
              className={styles.title}
              dangerouslySetInnerHTML={{ __html: tabs?.title }}
            ></div>
            <span className={styles.text}>{tabs?.description}</span>
          </div>
          <Tabs active={currentTab}>
            <TabPanel className={styles.tabs}>
              {changedTag?.map(renderTab)}
            </TabPanel>
            <TabContent>
              {changedTag?.map((item, index) => {
                return (
                  <TabContentItem
                    active={currentTab}
                    className={styles.numbers}
                    key={index}
                  >
                    <div className={styles.bookNumber}>
                      <SliderModule
                        {...sliderSetting}
                        className={`${styles.slider} slick-book-number`}
                      >
                        {numberList?.map(renderTabContent)}
                      </SliderModule>
                      {numberList?.length > 0 && (
                        <Button
                          onClick={() => {
                            window.dataLayer = window.dataLayer || [];
                            window.dataLayer.push({
                              event: 'beautifulnumber',
                            });
                            window.location.assign(
                              'https://nomre.bakcell.com/',
                            );
                          }}
                          className={styles.button}
                          Component={'router'}
                        >
                          {tabs?.order_button_text}
                        </Button>
                      )}
                      <ActiveLink href={'https://nomre.bakcell.com/'}>
                        <a
                          title={tabs?.view_all_text}
                          aria-label={tabs?.view_all_text}
                          className={styles.viewAll}
                        >
                          {tabs?.view_all_text}
                        </a>
                      </ActiveLink>
                    </div>
                  </TabContentItem>
                );
              })}
            </TabContent>
          </Tabs>
        </div>
        <div className={styles.right}>
          <div className={styles.content}>
            <span className={styles.text}>{tabs?.banner_text}</span>
            <Button
              className={styles.button}
              Component={'router'}
              href={tabs?.banner_button_slug}
            >
              {tabs?.banner_button_text}
            </Button>
          </div>
          {!isImageLoaded && (
            <Skeleton
              containerClassName={styles.skeletonContainer}
              height={450}
            />
          )}

          <picture
            style={{
              visibility: isImageLoaded ? 'visible' : 'hidden',
              width: !isImageLoaded && '0%',
            }}
          >
            <source media='(min-width:1024px)' srcSet={tabs?.banner_image} />
            <Image
              className={styles.image}
              src={tabs?.banner_image}
              width={350}
              height={450}
              layout='responsive'
              alt='bakcell'
              title='bakcell'
              loading='lazy'
              onLoadingComplete={() => setIsImageLoaded(true)}
            />
          </picture>
        </div>
      </div>
    </div>
  );
};

export default BookNumber;
